import React, { useState, useEffect } from 'react';
import styles from './Header.module.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.offsetTop;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };

  return (
      <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
        <div className={styles.container}>

          <button
              className={`${styles.mobileMenuBtn} ${mobileMenuOpen ? styles.active : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Меню"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`${styles.nav} ${mobileMenuOpen ? styles.open : ''}`}>
            <ul className={styles.navList}>
              <li className={styles.navItem}>
                <button onClick={() => scrollToSection('services')} className={styles.navLink}>
                  Услуги
                </button>
              </li>
              <li className={styles.navItem}>
                <button onClick={() => scrollToSection('training')} className={styles.navLink}>
                  Обучения
                </button>
              </li>
              <li className={styles.navItem}>
                <button onClick={() => scrollToSection('portfolio')} className={styles.navLink}>
                  Портфолио
                </button>
              </li>
              <li className={styles.navItem}>
                <button onClick={() => scrollToSection('contacts')} className={styles.navLink}>
                  Контакты
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>
  );
};

export default Header;